import { compose, withProps } from 'recompose';
import { withLabel } from '@/se/components/Label';
import TextInput from '@/se/components/inputs/TextInput';

export default compose(
  withLabel('Address'),
  withProps({ placeholder: 'e.g., 8910 Jolla Drive, La Jolla, CA 92037' })
)(TextInput);
